// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"3f2ee34e","506":"2452c40d","756":"f4501fbf"}[chunkId] + ".chunk.css";
};